<template>
  <div class="home">

    <gnetHeader v-if="showheader" v-bind:logo="$store.state.logoimage"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="'Portale Clienti'"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>
    <homehelp2></homehelp2>
  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import homehelp2 from '../components/homehelp2.vue'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    homehelp2
  },
  data: function() {
    return {
        showheader: true,
    };
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>

